import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { motion } from "framer-motion";

export default function Transactions() {
  const [tx, setTx] = useState([]);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/transactions").then(r => setTx(r.data)); }, []);
  const cats = ["all", ...new Set(tx.map(t => t.category))];
  const filtered = filter === "all" ? tx : tx.filter(t => t.category === filter);

  return (
    <div className="p-8 max-w-5xl mx-auto">
      <h1 className="font-heading text-3xl font-bold mb-6">Transactions</h1>
      <div className="flex gap-2 mb-6 flex-wrap">
        {cats.map(c => (
          <button key={c} data-testid={`filter-${c}`} onClick={() => setFilter(c)}
            className={`px-4 py-1.5 rounded-full text-xs uppercase tracking-wider transition ${filter === c ? "bg-[rgba(212,175,55,0.15)] text-[color:var(--gold)] border border-[rgba(212,175,55,0.4)]" : "border border-[rgba(212,175,55,0.15)] text-[color:var(--text-secondary)] hover:border-[rgba(212,175,55,0.3)]"}`}>
            {c}
          </button>
        ))}
      </div>
      <div className="glass-card divide-y divide-[rgba(212,175,55,0.08)]">
        {filtered.map((t, i) => (
          <motion.div key={t.transaction_id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: i * 0.02 }}
            className="p-4 flex items-center justify-between hover:bg-[rgba(212,175,55,0.03)] transition">
            <div>
              <div className="font-medium">{t.description}</div>
              <div className="text-xs text-[color:var(--text-muted)] mt-0.5">{new Date(t.date).toLocaleDateString()} · {t.category}</div>
            </div>
            <div className={`font-mono font-semibold ${t.amount > 0 ? "text-[color:var(--emerald)]" : "text-[color:var(--text-primary)]"}`}>
              {t.amount > 0 ? "+" : "-"}${Math.abs(t.amount).toFixed(2)}
            </div>
          </motion.div>
        ))}
        {!filtered.length && <div className="p-8 text-center text-[color:var(--text-muted)]">No transactions</div>}
      </div>
    </div>
  );
}
